import { createRoute } from '@tanstack/react-router';

import { ScheduleChangesPage } from '@web/ui/schedule_changes/views/schedule_changes_page';

import { settingsLayoutRoute } from './settings_routes';

/**
 * `/orgs/$orgSlug/settings/schedule-changes` — operator upload screen for
 * involuntary schedule changes, nested in the org-management settings shell.
 * Picks a processor type, uploads a file, and renders the per-row parse
 * outcome returned by the kanban-api bridge.
 */
export const scheduleChangesRoute = createRoute({
  getParentRoute: () => settingsLayoutRoute,
  path: 'schedule-changes',
  component: ScheduleChangesPage,
});
